module.exports = __webpack_public_path__ + "assets/img/gym_placeholder.0a4809f5.svg";